<template>
    <div>
        <div>

            <div :id="`card-element-${_uid}`" class="card-element"></div>
            <div :id="`card-errors-${_uid}`" class="card-errors" role="alert"></div>

        </div>

        <div class="mt-4">
            <div id="payment-request-button">
            </div>
        </div>
    </div>

</template>
<script>
    export default {

        props: ['value', 'amount'],

        data() {
            return {
                paymentRequest: null,
                stripeIntent: null,
                stripe: null,
                elements: null,
                card: null,
                stripePaymentOptions: {
                    applePay: false,
                    googlePay: false,
                    link: false,
                }
            }
        },

        created() {
            this.stripe = Stripe(config.stripeKey);
            App.bus.$on('checkout', () => this.card.update({disabled: true}))
            App.bus.$on('checkout-error', () => this.card.update({disabled: false}))
            App.bus.$on('checkout-clear', () => this.card.clear())
        },

        mounted() {
            this.createElements()
            this.addAlternativePaymentOptions()
        },

        methods: {

            createElements() {
                this.elements = this.stripe.elements();
                var style = {
                    base: {
                        color: '#32325d',
                        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                        fontSmoothing: 'antialiased',
                        fontSize: '16px',
                        '::placeholder': {
                            color: '#aab7c4'
                        }
                    },
                    invalid: {
                        color: '#fa755a',
                        iconColor: '#fa755a'
                    }
                };
                this.card = this.elements.create('card', { style });
                this.card.mount('#card-element-' + this._uid);
                this.card.addEventListener('change', event => {
                    var displayError = document.getElementById('card-errors-' + this._uid);
                    if (event.error) {
                        displayError.textContent = event.error.message;
                    } else {
                        displayError.textContent = '';
                    }
                    if(event.complete){
                        this.createPaymentMethodFromCard();
                    }
                });
            },

            // Create a Google Pay and Apple Pay buttons.
            addAlternativePaymentOptions() {

                if(!document.getElementById('payment-request-button') || this.amount == null){
                    return;
                }

                console.log(this.amount)

                this.paymentRequest = this.stripe.paymentRequest({
                    country: 'US',
                    currency: 'usd',
                    total: {
                        label: 'California Electrical Training',
                        amount: this.amount,
                    },
                    requestPayerName: true,
                    requestPayerEmail: true,
                });

                var prButton = this.elements.create('paymentRequestButton', {
                    paymentRequest: this.paymentRequest
                });

                this.paymentRequest.canMakePayment().then(result => {

                    if (result) {
                        this.stripePaymentOptions.applePay = result.applePay
                        this.stripePaymentOptions.googlePay = result.googlePay
                        this.stripePaymentOptions.link = result.link

                        prButton.mount('#payment-request-button');

                        this.paymentRequest.on('paymentmethod', event => {
                            if (event.paymentMethod.id) {
                                this.$emit('input', event.paymentMethod.id)
                            } else {
                                this.$emit('error');
                                this.$emit('input', null);
                            }
                            event.complete('success');
                        });
                    } else {
                        this.stripePaymentOptions.applePay = false
                        this.stripePaymentOptions.googlePay = false
                        document.getElementById('payment-request-button').style.display = 'none';
                    }
                });
            },

            createPaymentMethodFromCard() {
                this.stripe.createPaymentMethod({
                    type: 'card',
                    card: this.card
                })
                    .then(result => {
                        if(result.error){
                            var errorElement = document.getElementById('card-errors-' + this._uid);
                            errorElement.textContent = result.error.message;
                        }else{
                            this.$emit('input', result.paymentMethod.id)
                        }

                        // Handle result.error or result.paymentMethod
                    })
                    .catch(errors => {
                        console.log(errors)
                    })
            },
        },


        watch: {
            amount(){
                console.log('el monto cambio')
                this.paymentRequest.update({
                    total: {
                        label: 'California Electrical Training',
                        amount: this.amount,
                    },
                })
            }
        }
    }
</script>
<style>
    .card-element{
        border: 1px solid #cdd4da;
        border-radius: 4px;
        padding: 1rem;
        height: 3.125rem;
    }
    .card-element:focus {
        color: #5F91BA;
    }
    .card-errors{
        font-weight: 500;
        color: #dc3545;
        font-size: .85rem;
    }
</style>
